<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm">
            <div class="page-title line-height">通知公告-审核列表</div>
            <el-radio-group v-model="search">
                <el-radio :label="0" border>全部</el-radio>
                <el-radio :label="1" border>待审核</el-radio>
                <el-radio :label="2" border>未通过</el-radio>
                <el-radio :label="3" border>已通过</el-radio>
            </el-radio-group>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm list-search">
            <el-input
                v-model="keyWord"
                placeholder="请输入通知公告标题关键字"
            ></el-input>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        </div>
        <div class="ship-list">
            <el-table
                v-loading="loading"
                :data="lists" border
                header-row-class-name="table-header"
                style="width: 100%; border-radius: 10px">
                <el-table-column label="机构名称" prop="name">
                    <template slot-scope="scope">
                        <div class="table-name"> {{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="通知标题" prop="title">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{ scope.row.title }}元
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" width="80px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{ scope.row.state | status }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="flex justify-center  align-center">
                            <el-button class="table-operate red" v-if="scope.row.state === 1" @click="apply(scope.row.id,2)">拒绝
                            </el-button>
                            <el-button class="table-operate"  v-if="scope.row.state === 1" @click="apply(scope.row.id,3)">通过
                            </el-button>
                            <el-button class="table-operate line" @click="onPreview(scope.row.id)">查看
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all margin-top"
            layout="prev, pager, next, jumper"
            @current-change="init">
        </el-pagination>
    </div>
</template>

<script>
import {getExamineList, examineNoticeData} from '@/api/organiz'

export default {
    name: "cost",
    data() {
        return {
            keyWord: '',
            search: 0,
            lists: [],
            page: 1,
            limit: 13,
            total: 0,
            loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.init()
    },
    components: {},
    methods: {
        //  页面加载时请求
        async init() {
            this.loading = true
            let _data = await getExamineList(this.page, this.limit, this.search, this.keyWord)
            this.loading = false
            if (_data.status === 200) {
                this.lists = _data.data
                this.total = _data.count
            } else {
                this.lists = [];
                this.total = 0;
            }
        },
        apply(id,state) {
            if (state === 3){
                this.$confirm (`你确定通过该通知公告吗?`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.submitApply(id,state,'')
                })
            }else{
                this.$prompt('请输入拒绝原因', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '请输入拒绝原因'
                }).then(({ value }) => {
                    this.submitApply(id,state,value)
                })
            }

        },
        async submitApply(id,state,value){
            let _state = await examineNoticeData(id,value,state)
            if (_state.status === 200){
                this.$message.success(_state.msg)
                this.init()
            }
        },
        onPreview(id) {
            this.$router.push('/organization/notice/adetail/' + id)
        },

    },
    filters: {
        status(type) {
            switch (Number(type)) {
                case 1:
                    return "待审核";
                case 2:
                    return "审核驳回";
                default:
                    return "审核通过";
            }
        }
    },
    watch: {
        search() {
            this.page = 1
            this.init()
        }
    },
}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        width: 60px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background-color: #0a2240;
        border: solid 1px #0a2240;
        font-size: 14px;
        color: #ffffff;

        &.red {
            background-color: #ffffff;
            border: solid 1px #e4393c;
            color: #e4393c;
        }

        &.line {
            background-color: #ffffff;
            color: #0a2240;
        }

        &:disabled {
            background-color: #ffffff;
            border: solid 1px #dae0e6;
            color: #bcc6cf;
        }
    }
}
</style>